<template>
    <div>
        <van-dialog v-model="show" class="comPopup_container" :showConfirmButton="false" :showCancelButton="false"
            :closeable="true" @close="$emit('closePopup')">
            <div class="comPopup_title">
                {{ title }}
                <van-icon v-if="showiconClose" name="cross" class="comPopup_close" @click="$emit('closePopup')" />
            </div>
            <div class="comPopup_content pr-1 pl-1">
                <slot name="content"></slot>
            </div>
            <div class="comPopup_btn">
                <van-button v-if="showClose" class="comPopup_btn_cancel" type="default" block
                    @click="$emit('closePopup')">
                    {{ closeText }}
                </van-button>
                <van-button v-if="showBtn" class="comPopup_btn_primary" type="default" :loading="yesbtnLoading"
                    :loading-text="btnLabel" block @click="clickPopup">
                    {{ btnLabel }}
                </van-button>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { Loading } from 'vant';

export default {
    name: 'ComPopup',
    props: {
        value: {   //弹窗显隐
            type: Boolean,
            default: false
        },
        showiconClose: {  //关闭图标显隐
            type: Boolean,
            default: false
        },
        title: { //弹窗标题
            type: String,
            default: ''
        },
        showClose: { // 是否显示关闭按钮
            type: Boolean,
            default: true
        },
        // 是否显示确认按钮
        showBtn: {
            type: Boolean,
            default: true
        },
        btnLabel: {  //确认按钮文字
            type: String,
            default: '确认'
        },
        closeText: {  //关闭按钮文字
            type: String,
            default: '关闭'
        },
        yesbtnLoading: { //按钮状态
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hasDefaultContent: true,
            show: false
        }
    },
    mounted() {
        this.hasDefaultContent = !this.$slots.default;
    },
    methods: {
        clickPopup() {
            this.$emit('clickPopup')
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.show = val
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>